var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("span", { staticClass: "buttons" }, [
      _c(
        "button",
        {
          staticClass: "button is-warning is-outlined is-small",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("b-icon", { attrs: { icon: "chevron-left" } }),
          _c("span", [_vm._v(_vm._s(_vm.$t("global.close")))]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "has-text-centered" }, [
        _c("h2", { staticClass: "title" }, [
          _vm._v(" " + _vm._s(_vm.selectedMailDeclaration.enduserName) + " "),
        ]),
        _c("i", { staticClass: "title" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm
                  .$dayjs(_vm.selectedMailDeclaration.date)
                  .local()
                  .format("DD-MM-YYYY HH:mm")
              ) +
              " "
          ),
        ]),
        _c("br"),
        _c("i", [_vm._v(" (DD-MM-YYYY HH:mm) ")]),
      ]),
      _c("div", { staticClass: "mb" }, [
        _c("h2", { staticClass: "title" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("consignee.pickup_management.identity")) + " "
          ),
        ]),
        _c("div", { staticClass: "card" }, [
          _vm.selectedMailDeclaration.identity
            ? _c("span", { staticClass: "commentsSection" }, [
                _vm._v(
                  " " + _vm._s(_vm.selectedMailDeclaration.identity) + " "
                ),
              ])
            : _c("span", { staticClass: "commentsSection" }, [
                _c("i", [_vm._v(_vm._s(_vm.$t("global.no_data")))]),
              ]),
        ]),
      ]),
      _c("div", { staticClass: "mb" }, [
        _c("h2", { staticClass: "title" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("consignee.pickup_management.comments")) + " "
          ),
        ]),
        _c("div", { staticClass: "card" }, [
          _vm.selectedMailDeclaration.comments
            ? _c("span", { staticClass: "commentsSection" }, [
                _vm._v(
                  " " + _vm._s(_vm.selectedMailDeclaration.comments) + " "
                ),
              ])
            : _c("span", { staticClass: "commentsSection" }, [
                _c("i", [
                  _vm._v(
                    _vm._s(_vm.$t("consignee.pickup_management.no_comments"))
                  ),
                ]),
              ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "columns is-multiline" },
      _vm._l(_vm.selectedMailDeclaration.declarationQuantities, function (dc) {
        return _c(
          "div",
          { key: dc.material, staticClass: "column is-one-third" },
          [
            _c("div", { staticClass: "card has-text-centered" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("span", { staticClass: "card-header-title" }, [
                  _vm._v(" " + _vm._s(dc.material) + " "),
                ]),
              ]),
              _c("div", { staticClass: "card-content" }, [
                _c(
                  "h2",
                  {
                    staticClass: "title",
                    class: dc.quantity > 0 ? "has-text-primary" : null,
                  },
                  [_vm._v(" " + _vm._s(dc.quantity) + " ")]
                ),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }